import React from 'react'

import { OrderExtendedDetails } from '../../../api/services/orders/types.ts'
import Card from '../../common/Card/Card.tsx'
import FolderAssignment from '../../diets/DietSelector/FolderAssignment/FolderAssignment.tsx'
import ProfileOrdersHistory from '../profileOrdersHistory'

const AdditionalSection = ({
  order,
  refreshKey
}: {
  order: OrderExtendedDetails
  refreshKey: number
}) => {
  return (
    <Card className="w-full 2xl:w-1/2 box-border">
      <FolderAssignment
        order={order}
        refreshKey={refreshKey}
      />

      {order.patient_profile?.id && <ProfileOrdersHistory
        patientProfileId={order.patient_profile.id}
        currentOrderId={order.id}
        colSpans={[1, 2, 2, 3]}
      />}
    </Card>
  )
}

export default AdditionalSection
